import React, { useId } from 'react'
import PropTypes from 'prop-types'

const SparklesIcon = React.forwardRef(function SparklesIcon(props, ref) {
  const { color, size, ...otherProps } = props
  const clipPathId = useId()

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <g clipPath={`url(#${clipPathId})`}>
        <path d="M19 13C19.55 13 20 12.55 20 12C20 11.45 19.55 11 19 11H16C13.24 11 11 8.76 11 6V3C11 2.45 10.55 2 10 2C9.45 2 9 2.45 9 3V6C9 8.76 6.76 11 4 11H1C0.45 11 0 11.45 0 12C0 12.55 0.45 13 1 13H4C6.76 13 9 15.24 9 18V21C9 21.55 9.45 22 10 22C10.55 22 11 21.55 11 21V18C11 15.24 13.24 13 16 13H19Z"></path>
        <path d="M23 18H21C20.45 18 20 17.55 20 17V15C20 14.45 19.55 14 19 14 18.45 14 18 14.45 18 15V17C18 17.55 17.55 18 17 18H15C14.45 18 14 18.45 14 19 14 19.55 14.45 20 15 20H17C17.55 20 18 20.45 18 21V23C18 23.55 18.45 24 19 24 19.55 24 20 23.55 20 23V21C20 20.45 20.45 20 21 20H23C23.55 20 24 19.55 24 19 24 18.45 23.55 18 23 18ZM14 4H15V5C15 5.55 15.45 6 16 6 16.55 6 17 5.55 17 5V4H18C18.55 4 19 3.55 19 3 19 2.45 18.55 2 18 2H17V1C17 .45 16.55 0 16 0 15.45 0 15 .45 15 1V2H14C13.45 2 13 2.45 13 3 13 3.55 13.45 4 14 4Z"></path>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="white" d="M0 0H24V24H0z"></path>
        </clipPath>
      </defs>
    </svg>
  )
})

SparklesIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

SparklesIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default SparklesIcon
